"use client";

import { useState, useEffect, useRef, useCallback } from "react";
import { createPortal } from "react-dom";

interface IInfoTooltipButtonProps {
  text: string;
  size?: number;
}

interface TooltipPosition {
  top: number;
  left: number;
  alignRight: boolean;
}

function InfoIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M0 0 C1.45108658 0.00273422 1.45108658 0.00273422 2.93148804 0.00552368 C17.26440977 0.05095174 31.21023917 0.55983928 45.3125 3.3125 C46.65803955 3.55395752 46.65803955 3.55395752 48.03076172 3.80029297 C107.84088904 14.62287989 165.35495829 48.68064457 202.3125 97.3125 C202.72918945 97.85277832 203.14587891 98.39305664 203.57519531 98.94970703 C211.2584873 108.9447116 218.00092968 119.40459036 224.3125 130.3125 C224.70679199 130.98974121 225.10108398 131.66698242 225.50732422 132.36474609 C238.68961173 155.2833756 247.29510918 180.85822563 252.625 206.6875 C252.77243652 207.39817627 252.91987305 208.10885254 253.07177734 208.84106445 C256.05713787 224.48358366 256.6873098 240.11919606 256.625 256 C256.62226578 257.45108658 256.62226578 257.45108658 256.61947632 258.93148804 C256.57404826 273.26440977 256.06516072 287.21023917 253.3125 301.3125 C253.15152832 302.20952637 252.99055664 303.10655273 252.82470703 304.03076172 C242.00212011 363.84088904 207.94435543 421.35495829 159.3125 458.3125 C158.77222168 458.72918945 158.23194336 459.14587891 157.67529297 459.57519531 C147.6802884 467.2584873 137.22040964 474.00092968 126.3125 480.3125 C125.63525879 480.70679199 124.95801758 481.10108398 124.26025391 481.50732422 C101.3416244 494.68961173 75.76677437 503.29510918 49.9375 508.625 C49.22682373 508.77243652 48.51614746 508.91987305 47.78393555 509.07177734 C32.14141634 512.05713787 16.50580394 512.6873098 0.625 512.625 C-0.34239105 512.62317719 -1.3097821 512.62135437 -2.30648804 512.61947632 C-16.63940977 512.57404826 -30.58523917 512.06516072 -44.6875 509.3125 C-45.58452637 509.15152832 -46.48155273 508.99055664 -47.40576172 508.82470703 C-107.21588904 498.00212011 -164.72995829 463.94435543 -201.6875 415.3125 C-202.10418945 414.77222168 -202.52087891 414.23194336 -202.95019531 413.67529297 C-210.6334873 403.6802884 -217.37592968 393.22040964 -223.6875 382.3125 C-224.08179199 381.63525879 -224.47608398 380.95801758 -224.88232422 380.26025391 C-238.06461173 357.3416244 -246.67010918 331.76677437 -252 305.9375 C-252.14743652 305.22682373 -252.29487305 304.51614746 -252.44677734 303.78393555 C-255.43213787 288.14141634 -256.0623098 272.50580394 -256 256.625 C-255.99817719 255.65760895 -255.99635437 254.6902179 -255.99447632 253.69351196 C-255.94904826 239.36059023 -255.44016072 225.41476083 -252.6875 211.3125 C-252.44604248 209.96696045 -252.44604248 209.96696045 -252.19970703 208.59423828 C-241.37712011 148.78411096 -207.31935543 91.27004171 -158.6875 54.3125 C-158.14722168 53.89581055 -157.60694336 53.47912109 -157.05029297 53.04980469 C-147.0552884 45.3665127 -136.59540964 38.62407032 -125.6875 32.3125 C-125.01025879 31.91820801 -124.33301758 31.52391602 -123.63525391 31.11767578 C-100.7166244 17.93538827 -75.14177437 9.32989082 -49.3125 4 C-48.60182373 3.85256348 -47.89114746 3.70512695 -47.15893555 3.55322266 C-31.51641634 0.56786213 -15.88080394 -0.0623098 0 0 Z M-8 113.6875 C-14.34068881 121.49006984 -16.45176089 130.46202626 -15.6875 140.3125 C-14.39576499 147.58124614 -11.51840042 152.80031876 -6.6875 158.3125 C-5.57375 159.611875 -5.57375 159.611875 -4.4375 160.9375 C4.95675669 169.05072169 14.19796355 171.8194848 26.5234375 171.625 C36.95058604 170.76502899 46.58789931 165.66071801 53.625 157.9375 C60.92299885 148.81500143 61.97759887 139.69044135 61.3125 128.3125 C60.2043672 122.98368491 57.50901962 118.67139039 54.3125 114.3125 C53.755625 113.4875 53.19875 112.6625 52.625 111.8125 C45.99893032 104.64918142 36.48502955 99.98047603 26.75390625 99.07421875 C12.40494564 98.70429982 1.72278216 103.2633231 -8 113.6875 Z M-62.6875 217.3125 C-63.5851709 217.61873291 -64.4828418 217.92496582 -65.40771484 218.24047852 C-69.64709988 219.83930551 -71.27709931 220.54456683 -73.4765625 224.66015625 C-73.75242188 225.88605469 -74.02828125 227.11195313 -74.3125 228.375 C-74.76496094 230.21771484 -74.76496094 230.21771484 -75.2265625 232.09765625 C-75.93347169 235.32070151 -75.93347169 235.32070151 -74.6875 238.3125 C-73.86507812 238.03535156 -73.04265625 237.75820312 -72.1953125 237.47265625 C-60.35927581 233.63209469 -49.96498728 231.99952724 -37.6875 235.3125 C-34.45210364 237.28993806 -32.99387234 238.64853806 -31.40234375 242.09765625 C-29.13452461 252.29664615 -30.44823966 262.56845988 -32.70703125 272.6328125 C-32.92467133 273.61665421 -33.1423114 274.60049591 -33.36654663 275.614151 C-36.29886477 288.47494381 -40.0871805 301.1016533 -43.8125 313.75 C-56.37824954 351.37345631 -56.37824954 351.37345631 -51.625 389.5 C-45.55552242 400.44610985 -35.50405714 407.32973636 -23.6394043 410.93481445 C-17.59741554 412.45086804 -11.70639942 412.64586886 -5.5 412.625 C-4.09137695 412.64916992 -4.09137695 412.64916992 -2.65429688 412.67382812 C10.61191747 412.68280999 22.68015179 408.80087333 34.93066406 404.12402344 C37.09687589 403.29941417 39.27041414 402.49669309 41.4453125 401.6953125 C42.83381058 401.17314228 44.22185045 400.64975163 45.609375 400.125 C46.2550946 399.88740967 46.90081421 399.64981934 47.56610107 399.4050293 C50.99370055 398.07884506 52.20780945 397.46953582 54.3125 394.3125 C54.91671492 391.93167147 55.4515323 389.53274906 55.9375 387.125 C56.19789063 385.85269531 56.45828125 384.58039063 56.7265625 383.26953125 C56.91992188 382.29371094 57.11328125 381.31789063 57.3125 380.3125 C55.73275391 380.745625 55.73275391 380.745625 54.12109375 381.1875 C41.78162935 384.42434059 26.17196068 387.85642087 14.3125 381.3125 C13.08203125 378.88671875 13.08203125 378.88671875 12.3125 376.3125 C11.9825 375.3225 11.6525 374.3325 11.3125 373.3125 C10.53862761 363.62803975 11.17954826 354.44732259 13.328125 344.9765625 C13.65500809 343.50653275 13.65500809 343.50653275 13.98849487 342.00680542 C17.25064532 327.74720004 21.45544975 313.72938963 25.52490234 299.68457031 C33.1969697 274.25439333 33.1969697 274.25439333 35.75 247.9375 C35.74242676 247.09735352 35.73485352 246.25720703 35.72705078 245.39160156 C35.39798265 232.97348291 30.50636303 224.19701855 21.75 215.625 C12.88731396 208.25904841 1.48524111 206.29712345 -9.6875 205.3125 C-10.44160156 205.2403125 -11.19570312 205.168125 -11.97265625 205.09375 C-29.28584854 204.29313995 -46.77701361 211.46982016 -62.6875 217.3125 Z"
        fill="#102c57"
        transform="translate(255.6875,-0.3125)"
      />
    </svg>
  );
}

const TOOLTIP_WIDTH = 280; // max-w-[280px] — must match the CSS max-width for flip calculations
const TOOLTIP_MAX_HEIGHT = 160; // estimated max rendered height used for above/below flip decision
const TOOLTIP_OFFSET = 8;
const HOVER_CLOSE_DELAY = 120;

export function InfoTooltipButton({ text, size = 18 }: IInfoTooltipButtonProps) {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [position, setPosition] = useState<TooltipPosition>({ top: 0, left: 0, alignRight: false });
  const buttonRef = useRef<HTMLButtonElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setMounted(true);
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  const calculatePosition = useCallback(() => {
    if (!buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const tooltipH = tooltipRef.current?.getBoundingClientRect().height || TOOLTIP_MAX_HEIGHT;

    const spaceRight = vw - rect.left;
    const alignRight = spaceRight < TOOLTIP_WIDTH + 16;

    let top = rect.bottom + TOOLTIP_OFFSET;
    if (top + tooltipH > vh) {
      top = rect.top - tooltipH - TOOLTIP_OFFSET;
    }

    const left = alignRight
      ? rect.right - TOOLTIP_WIDTH
      : rect.left;

    setPosition({ top, left: Math.max(8, left), alignRight });
  }, []);

  const openTooltip = useCallback(() => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    calculatePosition();
    setVisible(true);
  }, [calculatePosition]);

  const scheduleClose = useCallback(() => {
    closeTimerRef.current = setTimeout(() => setVisible(false), HOVER_CLOSE_DELAY);
  }, []);

  const cancelClose = useCallback(() => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (!visible) return;
    const handleDocClick = (e: MouseEvent) => {
      if (
        buttonRef.current?.contains(e.target as Node) ||
        tooltipRef.current?.contains(e.target as Node)
      ) return;
      setVisible(false);
    };
    document.addEventListener("mousedown", handleDocClick);
    return () => document.removeEventListener("mousedown", handleDocClick);
  }, [visible]);

  const tooltip = mounted && visible && typeof document !== "undefined"
    ? createPortal(
        <div
          ref={tooltipRef}
          role="tooltip"
          onMouseEnter={cancelClose}
          onMouseLeave={scheduleClose}
          style={{
            position: "fixed",
            top: position.top,
            left: position.left,
            zIndex: 9999,
          }}
          className="bg-gray-900/90 text-white rounded text-sm p-3 max-w-[280px] lg:max-w-[360px] shadow-lg"
        >
          <p>{text}</p>
        </div>,
        document.body
      )
    : null;

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="flex items-center justify-center cursor-pointer focus:outline-none"
        aria-label="More information"
        aria-expanded={visible}
        onMouseEnter={openTooltip}
        onMouseLeave={scheduleClose}
        onFocus={openTooltip}
        onBlur={scheduleClose}
        onClick={openTooltip}
      >
        <InfoIcon size={size} />
      </button>
      {tooltip}
    </>
  );
}
